import { SET_SETTING_CONFIG } from '../types/shopSetting'

import { getSettingConfigAPI, updateSettingConfigAPI } from '../api/shopSetting'

import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setSettingConfig = (payload) => ({
  type: SET_SETTING_CONFIG,
  payload,
})

export const getSettingConfig = (groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getSettingConfigAPI(groupName), dispatch).then((res) => {
        dispatch(setSettingConfig(res))
        resolve(res)
      })
    })
  }
}

export const updateSettingConfig = (data, groupName) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateSettingConfigAPI(data, groupName), dispatch).then((data) => {
        resolve(data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/shopSetting.js